export const EMAIL_STATUS = {
  SENT: 'Sent',
  OPENED: 'Opened',
  NA: 'Pending',
  ERROR: 'Error'
}
